export default __webpack_public_path__ + "static/media/Big.65e47e3e.svg";